import './RecentNewsItem.css';
import { Link } from 'react-router-dom';
import { getFullDate } from '../../services/DateService.js';

function RecentNewsItem(props) {
  return (
    <div className="d-flex flex-column align-items-center recent-news-item">
      <div className="recent-news-item__image-wrapper">
        <Link to={`/news/${props.item.id}`}>
          <div className="recent-news-item__image" style={{ backgroundImage: `url(${props.item.mainImg})` }}>
            <time className="recent-news-item__date">{getFullDate(props.item.date)}</time>
          </div>
        </Link>
      </div>
      <Link className="recent-news-item__title-link" to={`/news/${props.item.id}`}>
        <h5 className="recent-news-item__title">{props.item.title}</h5>
      </Link>
    </div>
  );
}

export default RecentNewsItem;